module.exports = __webpack_public_path__ + "img/logo-updated.47c61274.png";